import { Components } from "@mui/material/styles/components";

export default {
  MuiToggleButton: {
    defaultProps: {
      disableRipple: true,
    },
    styleOverrides: {
      root: {
        textTransform: "none",
        height: 37,
        borderRadius: 7,
        paddingLeft: 20,
        paddingRight: 20,
      },
    },
  } as Components["MuiToggleButton"],
};
